module.exports = __webpack_public_path__ + "static/media/calendar_icon.2cde5d04.png";